import React from 'react';
import PropTypes from 'prop-types';

const ConditionalComponent = ({
  condition,
  children,
  elseChildren = null
}) => {
  if (!condition) {
    return elseChildren;
  }

  return (
    <div>
      { children }
    </div>
  );
};

ConditionalComponent.propTypes = {
  condition: PropTypes.bool,
  children: PropTypes.any.isRequired,
  elseChildren: PropTypes.any
};

export default ConditionalComponent;


// WEBPACK FOOTER //
// src/Components/ConditionalComponent.jsx